module.exports = __webpack_public_path__ + "img/mypage06.48138f58.png";